import React, { useEffect, useState } from "react";
import { Box, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import ModalContainer from "components/ModalContainer";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";
import { getDefaultTableProp } from "../../theme";
import iconSwitch from "assets/images/icons/icn_dashboard_switch_off.svg";
import iconSwitchOffline from "assets/images/icons/icn_dashboard_switch.svg";
import AuthenticationFields from "./AuthenticationFields";

const BatchAuthenticationModal = ({ open, devices, onClose, onSubmit }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (open) {
      setUsername("");
      setPassword("");
    }
  }, [open]);

  const handleSubmit = () => {
    if (!username.trim() || !password || !devices.length) return;
    onSubmit(username.trim(), password);
    onClose();
  };

  return (
    <ModalContainer display={open} modalWidth="90p">
      <Box sx={{ minWidth: 0 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography color="#172664" fontWeight={600} fontSize="20px">
            Authentication
          </Typography>
          <IconButton onClick={onClose} size="small" aria-label="Close" sx={{ mr: "-20px" }}>
            <CloseOutlined style={{ color: "#172664", fontSize: 22 }} />
          </IconButton>
        </Box>

        <Box sx={{ margin: "20px 0", maxHeight: 400, overflow: "auto" }}>
          <Table sx={{ tableLayout: "fixed" }}>
            <TableHead sx={getDefaultTableProp().tableHead.sx}>
              <TableRow sx={getDefaultTableProp().tableHead.tableRow.sx}>
                {[{ label: "Model Name", width: "45%" }, { label: "MAC address", width: "32%" }, { label: "IP address", width: "23%" }].map(({ label, width }) => (
                  <TableCell key={label} sx={{ ...getDefaultTableProp().tableHead.tableCell.text, width }}>{label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {devices.map((device, index) => (
                <TableRow key={device.id} sx={{
                  ...getDefaultTableProp(index).tableBody.tableRow,
                  backgroundColor: index % 2 === 0 ? "#f6f6f6" : "#ffffff",
                  height: 88,
                }}>
                  <TableCell sx={getDefaultTableProp().tableBody.tableCell.text}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <img src={device.linkStatus === "online" ? iconSwitch : iconSwitchOffline} alt="Switch" style={{ width: 60, marginRight: 8 }} />
                      {device.modelName}
                    </Box>
                  </TableCell>
                  <TableCell sx={getDefaultTableProp().tableBody.tableCell.text}>{device.macAddress}</TableCell>
                  <TableCell sx={getDefaultTableProp().tableBody.tableCell.text}>{device.ipAddress}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <AuthenticationFields
          username={username}
          setUsername={setUsername}
          password={password}
          setPassword={setPassword}
        />
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
          <OutlineButton height="42px" width="150px" onClick={onClose}>Cancel</OutlineButton>
          <SolidButton height="42px" width="150px" disabled={!username.trim() || !password} onClick={handleSubmit}>Next</SolidButton>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export default BatchAuthenticationModal;
